import Utils from '../../utils/utils';

module.exports = ({  }) => `The package can be found at <a href="https://crates.io/crates/flagsmith">https://crates.io/crates/flagsmith</a>;`;
